var MemberSettingAuthMode = /* @__PURE__ */ ((MemberSettingAuthMode2) => {
  MemberSettingAuthMode2["PhonePin"] = "phone-pin";
  MemberSettingAuthMode2["UsernamePassword"] = "username-password";
  return MemberSettingAuthMode2;
})(MemberSettingAuthMode || {});
var MemberSettingFundingMode = /* @__PURE__ */ ((MemberSettingFundingMode2) => {
  MemberSettingFundingMode2["EWalletOnly"] = "e-wallet-only";
  MemberSettingFundingMode2["BankOnly"] = "bank-only";
  MemberSettingFundingMode2["BankEWallet"] = "bank-e-wallet";
  return MemberSettingFundingMode2;
})(MemberSettingFundingMode || {});
var MemberSettingNameMode = /* @__PURE__ */ ((MemberSettingNameMode2) => {
  MemberSettingNameMode2["FullInFirst"] = "full-in-first";
  MemberSettingNameMode2["FirstLast"] = "first-last";
  MemberSettingNameMode2["FirstMiddleLast"] = "first-middle-last";
  return MemberSettingNameMode2;
})(MemberSettingNameMode || {});
var MemberSettingDepositMethodGrouping = /* @__PURE__ */ ((MemberSettingDepositMethodGrouping2) => {
  MemberSettingDepositMethodGrouping2["Individual"] = "individual";
  MemberSettingDepositMethodGrouping2["Group"] = "group";
  return MemberSettingDepositMethodGrouping2;
})(MemberSettingDepositMethodGrouping || {});
var MemberSettingPlayerNameCollectionMode = /* @__PURE__ */ ((MemberSettingPlayerNameCollectionMode2) => {
  MemberSettingPlayerNameCollectionMode2["Registration"] = "registration";
  MemberSettingPlayerNameCollectionMode2["FirstDeposit"] = "first-deposit";
  MemberSettingPlayerNameCollectionMode2["FirstWithdrawal"] = "first-withdrawal";
  return MemberSettingPlayerNameCollectionMode2;
})(MemberSettingPlayerNameCollectionMode || {});
var MemberSettingDownloadBannerAction = /* @__PURE__ */ ((MemberSettingDownloadBannerAction2) => {
  MemberSettingDownloadBannerAction2["DownloadPwa"] = "download-pwa";
  MemberSettingDownloadBannerAction2["OpenExternalUrl"] = "open-external-url";
  return MemberSettingDownloadBannerAction2;
})(MemberSettingDownloadBannerAction || {});
var MemberUniqueInfoCollection = /* @__PURE__ */ ((MemberUniqueInfoCollection2) => {
  MemberUniqueInfoCollection2["PAN"] = "pan";
  MemberUniqueInfoCollection2["CURP"] = "curp";
  MemberUniqueInfoCollection2["CPF"] = "cpf";
  return MemberUniqueInfoCollection2;
})(MemberUniqueInfoCollection || {});
var MemberBankFundingType = /* @__PURE__ */ ((MemberBankFundingType2) => {
  MemberBankFundingType2["PIX"] = "pix";
  MemberBankFundingType2["IFSC"] = "ifsc";
  MemberBankFundingType2["UPI"] = "upi";
  MemberBankFundingType2["CLABE"] = "clabe";
  MemberBankFundingType2["DEFAULT"] = "default";
  return MemberBankFundingType2;
})(MemberBankFundingType || {});
export {
  MemberBankFundingType,
  MemberSettingAuthMode,
  MemberSettingDepositMethodGrouping,
  MemberSettingDownloadBannerAction,
  MemberSettingFundingMode,
  MemberSettingNameMode,
  MemberSettingPlayerNameCollectionMode,
  MemberUniqueInfoCollection
};
